import { LoadableLazy } from '@confluence/loadable';

export const ExtensionConfigUpsellLoader = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ExtensionConfigUpsell" */ '../src/CompanyHub/ExtensionConfigUpsell.tsx'
			)
		).ExtensionConfigUpsell,
});

export const ExtensionInsertUpsellLoader = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ExtensionInsertUpsell" */ '../src/CompanyHub/ExtensionInsertUpsell.tsx'
			)
		).ExtensionInsertUpsell,
});

export type { ExtensionSource } from '../src/CompanyHub/companyHubUpsellTypes.ts';
